<template>
	<div>
		<van-popup v-model="registeredShow"  @click-close-icon='close' >
			<van-icon class="close" name="cross" @click='close' />
			<div class="title">立即注册</div>
			<van-cell-group class="form">
				<van-field
          v-model="contact"
          placeholder="请输入手机号"
          maxlength="11"
          @blur="reg"
        />
				<van-field
          v-model="code"
          center
          clearable
          placeholder="验证码"
          @blur="word"
        >
          <van-button
            slot="button"
            size="small"
            class="reg-button"
            @click="getCode"
            :text="btnTitle"
            :disabled="disabled1"
          ></van-button>
        </van-field>
				<van-field
          v-model="name"
          placeholder="公司名称"
          maxlength="11"
          @blur="conpany"
        />
        <van-checkbox
					class="checkbox"
          icon-size="15px"
          checked-color="#07c160"
          v-model="checked"
          shape="square"
        >
          我已阅读并同意
          <a href="javascript:void(0)" class="protocol" @click.stop="protpcol">客户服务协议</a>
        </van-checkbox>
				<van-button type="primary" class="reg-form-button" @click="onSubmit" :disabled="disabled">注册</van-button>
			</van-cell-group>
		</van-popup>
		<van-popup v-model="registeredSuccess" @click-close-icon='closeSunccess' >
			<van-icon class="close" name="cross" @click='closeSunccess' />
			<div class="successTitle">注册成功!</div>
			<div class="successContent">您已成功注册上海田野农产品配送集团有限公司旗下的移动平台产品,在该款产品上购买商品需要我们的后台人员确认您的信息,我们的销售人员将在1-3个工作日内与您电话联系。</div>
		</van-popup>
	</div>
</template>

<script>
export default {
	props:{
		registeredShow: {
			type: Boolean,
      default: false
		},
	},
	data() {
		return {
			contact:'',
			code:'',
			name:'',
      patt: /^1[0-9]{10}$/,
			disabled:false,
      disabled1: false,
      btnTitle: "获取验证码",
			checked:false,
			registeredSuccess:false,
		}
	},
	methods: {
		async onSubmit() {
			let param = {
				contact:this.contact,
			}
			if (!this.patt.test(this.contact)) {
				this.$toast("请输入正确的手机号");
			} else if (this.code === "") {
				this.$toast("请输入验证码");
			} else	if (this.name === "") {
				this.$toast("请输入公司名称");
			} else if (!this.checked) {
				this.$toast("请勾选我已阅读");
			}else {
				this.$axios
				.post('/crm/permit/customerClue/check',param)
				.then(res => {
					if(res.data.data) {
						let params = {
							contact:this.contact,
							code:this.code,
							name:this.name,
						}
						this.$axios.post('crm/permit/customerClue/save',params)
							.then(res => {
								if(res.status === 200) {
									this.$toast('注册成功')
									this.registeredSuccess = true;
								}
							})
							.catch((err) => {
								this.$toast(err);
								return err;
							})
					} else {
							this.$toast("手机号已经注册过")
					}
				})
				.catch(() => {})
			}
		},
		close() {
			this.$emit('close')
		},
		closeSunccess() {
			this.registeredSuccess = false
			this.$emit('closeSunccess')
		},
		// 校验手机号
    reg() {
      if (!this.patt.test(this.contact)) {
        this.$toast("请输入正确的手机号");
      }
    },
    // 校验验证码
    word() {
      if (this.code === "") {
        this.$toast("请输入验证码");
      }
    },
		// 公司名称校验
		conpany() {
			if (this.name === "") {
        this.$toast("请输入公司名称");
      }
		},
		getCode() {
      this.$axios
        .get(
          `/auth/smsAuth/code?action=enroll&authType=2&mobile=${this.contact}`
        )
        .then(res => {
          if (res.data.code == 1) {
            this.$toast(res.data.msg);
          } else if (res.data.code == 0) {
            //倒计时
            let time = 60;
            let timer = setInterval(() => {
              if (time == 0) {
                clearInterval(timer);
                this.disabled1 = false;
                this.btnTitle = "获取验证码";
              } else {
                this.btnTitle = time + "秒后重试";
                this.disabled1 = true;
                time--;
              }
            }, 1000);
          }
				});
		},
		protpcol() {
      this.$router.push({ path: "/protocol"});
    },
	},

}

</script>

<style scoped lang='scss'>
.van-popup {
  width: 100%;
  height: 100%;
	text-align: center;
}
.title {
	font-size: 24px;
	font-weight: 700;
	margin-top: 100px;
}
.close {
	font-size: 24px;
	position: absolute;
	top: 10px;
	left: 10px;
}
.form {
	padding: 20px 30px;
	border: none;
}
.van-hairline--top-bottom::after {
	border: none;
}
.van-cell {
	border-bottom: 1px solid #ccc;
}
.reg-button {
	height:24px;
	border:none;
	color:#07c160
}
.checkbox {
	margin-top:20px;
	padding-left:10px;
	font-size:12px;
}
/deep/ .van-checkbox__icon {
 font-size: 12px !important; 
}
.reg-form-button {
	margin-top:40px;
	width:300px;
}
.successTitle {
	position: absolute;
	font-size: 30px;
	font-weight: 700;
	top: 130px;
	transform: translate(-50%);
	left: 50%;
}
.successContent{
	font-size: 18px;
	position: absolute;
	top: 230px;
	padding:0 40px;
	text-align: left;
	text-indent:2em;
	line-height: 32px;
}
.protocol {
	color: #07c160;
	text-decoration:underline
}
</style>